import { createContext, useContext, useState, useEffect, useCallback, useRef } from "react";
import { resolveApiUrl } from "../utils/useApiStable";

const BackendHealthContext = createContext(null);

export const useBackendHealth = () => useContext(BackendHealthContext);

const RETRY_INTERVAL_MS = 8000;

export const BackendHealthProvider = ({ children }) => {
  const [status, setStatus] = useState("checking"); // "checking" | "online" | "offline"
  const retryTimerRef = useRef(null);

  const checkHealth = useCallback(async () => {
    const apiUrl = resolveApiUrl();
    try {
      const response = await fetch(`${apiUrl}/public/tournament-info`, {
        method: "GET",
        credentials: "include",
        signal: AbortSignal.timeout(5000),
      });
      if (response.ok || response.status === 401 || response.status === 403) {
        setStatus("online");
      } else if (response.status >= 500 || response.status === 503) {
        setStatus("offline");
      } else {
        setStatus("online");
      }
    } catch {
      setStatus("offline");
    }
  }, []);

  useEffect(() => {
    checkHealth();
  }, [checkHealth]);

  useEffect(() => {
    if (status === "offline") {
      retryTimerRef.current = setInterval(checkHealth, RETRY_INTERVAL_MS);
    } else {
      clearInterval(retryTimerRef.current);
    }
    return () => clearInterval(retryTimerRef.current);
  }, [status, checkHealth]);

  return (
    <BackendHealthContext.Provider value={{ status, retry: checkHealth }}>
      {children}
    </BackendHealthContext.Provider>
  );
};
